<template>   
<div class="input-area">     
<el-form ref="loginForm" :model="loginForm">       
<el-form-item prop="phoneNumber">         
<el-input autoId="input_loginForm_phoneNumber" class="input-item" v-model="loginForm.phoneNumber" maxlength="11" placeholder="请输入手机号"> 
</el-input>       
</el-form-item>       
<el-form-item prop="">         <drag-verify           class="drag"           ref="dragVerify"           :isPassing.sync="isPassing"           :width="320"           completedBg="#79C23D"           text="验证码"           successText="验证通过"           handlerIcon="el-icon-arrow-right"           successIcon="el-icon-check"           @passcallback="success"         >         </drag-verify>       
</el-form-item>       
<el-form-item v-if="showTimeDown" prop="code">         
<div class="input-item code-input">           
<el-input autoId="input_loginForm_code" v-model="loginForm.code" maxlength="11" placeholder="验证码"> 
</el-input>           <span v-show="timeDown === 60" @click="timing">{{ timeDesc }}</span>           <span v-show="timeDown !== 60" class="code-disabled">倒计时 {{ timeDown }} s</span>         
</div>       
</el-form-item>       
<el-form-item prop="password">         
<el-input autoId="input_loginForm_password" class="input-item" v-model="loginForm.password" maxlength="20" @focus="inputFocus" @blur="inputBlur" :placeholder="placeholderInfo" show-password> 
</el-input>       
</el-form-item>        
<el-form-item v-if="loginType !== 'binding'" prop="confirmPassword">         
<el-input autoId="input_loginForm_confirmPassword" class="input-item" v-model="loginForm.confirmPassword" maxlength="20" placeholder="请再次输入密码" show-password> 
</el-input>       
</el-form-item>       
<el-form-item>         
<el-button autoId="btn_submit" class="submit" type="primary" @click="submit">{{ loginType === 'binding' ? '绑定' : '完成' }} 
</el-button>       
</el-form-item>        
<el-form-item v-if="loginType === 'binding'" prop="check">         
<div class="login-tips">           
<el-checkbox autoId="checkbox_loginForm_checked" v-model="loginForm.checked" />           我已阅读并接受<span @click="goTo('userAgreement')">《用户协议》</span> 和<span @click="goTo('privacyPolicy')">《隐私政策》 </span>          
</div>       
</el-form-item>     
</el-form>   
</div> </template>

<script>
import { password, checkPhoneFormat } from '@/utils/ruoyi.js'
import dragVerify from 'vue-drag-verify2'
import { changePwdPhone, changePwd, forgotPwd } from '@/api/login'
import { Message } from 'element-ui'
export default {
  props: {
    loginType: {
      type: String,
      default: ''
    }
  },
  components: {
    dragVerify
  },
  data() {
    return {
      isPassing: false,
      showTimeDown: false,
      timer: null,
      timeDesc: '发送验证码',
      placeholderInfo: '请输入新密码',
      timeDown: 60,
      loginForm: {
        phoneNumber: '',
        password: '',
        code: '',
        confirmPassword: '',
        checked: false
      }
    }
  },
  created() {
    const user = this.$store.state.user.userInfo || {}
    if (user.phonenumber) this.loginForm.phoneNumber = user.phonenumber
  },
  methods: {
    inputFocus() {
      this.placeholderInfo = '12~20位/数字/小写/大写字母和特殊符号4类'
    },
    inputBlur() {
      this.placeholderInfo = '请输入新密码'
    },
    submit() {
      switch (this.loginType) {
        case 'forget':
          this.submitForget()
          break
        case 'binding':
          this.submitBinding()
          break
        default:
          this.submitModify()
          break
      }
    },
    /** 修改密码 */
    submitModify() {
      if (!this.validate()) {
        return
      }
      let newForm = Object.assign({}, this.loginForm);
      newForm.password = this.$aesEncrypt.encrypt(newForm.password)
      if(newForm.confirmPassword) newForm.confirmPassword = this.$aesEncrypt.encrypt(newForm.confirmPassword)
      changePwd(newForm)
        .then(() => {
          this.$emit('success')
          this.$refs.loginForm.resetFields()
        })
        .catch(() => {
          this.loading = false
        })
    },
    /** 忘记密码 */
    submitForget() {
      if (!this.validate()) {
        return
      }
      let newForm = Object.assign({}, this.loginForm);
      newForm.password = this.$aesEncrypt.encrypt(newForm.password)
      if(newForm.confirmPassword) newForm.confirmPassword = this.$aesEncrypt.encrypt(newForm.confirmPassword)
      forgotPwd(newForm)
        .then(() => {
          this.$emit('success')
          this.$refs.loginForm.resetFields()
        })
        .catch(() => {
          this.loading = false
        })
    },
    /** 绑定密码 */
    submitBinding() {
      if (!this.validateBinding()) {
        return
      }
      let newForm = Object.assign({}, this.loginForm);
      newForm.password = this.$aesEncrypt.encrypt(newForm.password)
      if(newForm.confirmPassword) newForm.confirmPassword = this.$aesEncrypt.encrypt(newForm.confirmPassword)
      changePwd(newForm)
        .then(() => {
          this.$emit('success')
          this.$refs.loginForm.resetFields()
          Message({ message: '绑定成功', type: 'success' })
          this.$store.dispatch('openLogin', false)
        })
        .catch(() => {
          this.loading = false
        })
    },
    validateBinding() {
      const form = this.loginForm
      if (!form.password || !form.code || !form.phoneNumber) {
        Message({ message: '请将信息填写完整', type: 'error' })
        return false
      }
      if (!checkPhoneFormat(form.phoneNumber)) {
        Message({ message: '手机号格式不正确', type: 'error' })
        return
      }
      if (!form.checked) {
        Message({ message: '请勾选用户协议与隐私政策', type: 'error' })
        return false
      }
      if (!password(form.password)) {
        return false
      }
      form.confirmPassword = form.password
      return true
    },
    validate() {
      const form = this.loginForm
      if (form.password !== form.confirmPassword) {
        Message({ message: '两次密码不一致', type: 'error' })
        return false
      }
      if (!form.password || !form.confirmPassword || !form.code || !form.phoneNumber) {
        Message({ message: '请将信息填写完整', type: 'error' })
        return false
      }
      if (!checkPhoneFormat(form.phoneNumber)) {
        Message({ message: '手机号格式不正确', type: 'error' })
        return
      }
      if (!password(form.password)) {
        return false
      }
      return true
    },
    success() {
      this.showTimeDown = true
    },
    goTo(key) {
      this.$store.dispatch('openLogin', false)
      const id = this.$store.state.app.toolbar[key]
      const list = this.$store.state.user.link
      const item = list.filter((item) => item.contentIdList[0] === id)[0]
      // this.$router.push(`blog-detail?id=${id}`)
      if (!item) {
        Message({ message: `未获取到${key ==='userAgreement' ? '用户协议' : '隐私政策'}`, type: 'error' })
        return
      }
      this.$router.push({
        name: 'blogDetail',
        query: {
          menuId: item.menuId,
          contentType: item.contentType,
          menuName: item.menuName,
          parentId: item.parentId
        }
      })
    },
    timing() {
      if (!checkPhoneFormat(this.loginForm.phoneNumber)) {
        Message({ message: '手机号格式不正确', type: 'error' })
        return
      }
      if (this.timeDown === 60 && !this.timer) {
        this.timeDown -= 1
        this.timer = setInterval(() => {
          this.timeDown -= 1
          if (this.timeDown === 0) {
            clearInterval(this.timer)
            this.timer = null
            this.timeDown = 60
            this.timeDesc = '发送验证码'
          }
        }, 1000)
        changePwdPhone({phoneNumber:this.loginForm.phoneNumber}).then((res) => {})
      }
      return
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
.input-area {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
.input-item {
  height: 40px;
  overflow: hidden;
  margin-bottom: 8px;
  border: 1px solid #dedede;
  border-radius: 0;
  ::v-deep input {
    border: none;
  }
}
.code-input {
  display: flex;
  .el-input {
    width: 70%;
  }
  span {
    flex: 1;
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color);
  }
  .code-disabled {
    color: #999999;
  }
}
.submit {
  width: 100%;
  background: var(--color) !important;
  border: none;
  border-radius: 0;
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
  &:hover,
  &:active {
    background: rgba(18, 161, 130, 0.68);
  }
}
i {
  cursor: pointer;
  margin-top: 32px;
  text-align: center;
  color: var(--color);
  font-size: 38px;
}
.drag {
  margin-bottom: 8px;
  border: 1px solid #dedede;
  height: 40px;
  line-height: 40px;
  border-radius: 4px !important;
  ::v-deep > div {
    border-radius: 4px !important;
  }
}
.input-item {
  margin-bottom: 8px;
  border-radius: 4px;
}
::v-deep .el-form-item__content {
  line-height: 1;
}
.login-tips {
  width: 287px;
  margin-top: 12px;
  font-size: 12px;
  color: #cccccc;
  letter-spacing: 0;
  font-weight: 400;
  span {
    cursor: pointer;
    color: var(--color);
  }
}
::v-deep .el-checkbox .is-checked .el-checkbox__inner {
  background-color: var(--color);
  border-color: var(--color);
}
</style>
